// src/finance/components/SaveBadge.tsx
import type { AutosaveStatus } from '../useAutosave'

const LABELS: Record<Exclude<AutosaveStatus, 'idle'>, { text: string; color: string }> = {
  saving: { text: 'Enregistrement…', color: 'var(--dim)' },
  saved: { text: 'Enregistré', color: 'var(--muted)' },
  error: { text: "Erreur d'enregistrement", color: 'var(--arancio)' },
}

export function SaveBadge({ status }: { status: AutosaveStatus }) {
  if (status === 'idle') return null
  const { text, color } = LABELS[status]
  return (
    <span
      data-testid="save-badge"
      style={{
        fontSize: '0.75rem',
        color,
        border: '1px solid var(--line)',
        borderRadius: '4px',
        padding: '0.125rem 0.5rem',
        background: 'var(--elevated)',
      }}
    >
      {text}
    </span>
  )
}
